import script from "./OptionsBody.vue?vue&type=script&setup=true&lang=ts"
export * from "./OptionsBody.vue?vue&type=script&setup=true&lang=ts"

import "./OptionsBody.vue?vue&type=style&index=0&id=31e7a960&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31e7a960"]])

export default __exports__